// @flow
import { IncidenciasActionTypes } from './constants';

type IncidenciasAction = { type: string, payload: {} | string };

// common success
export const incidenciasApiResponseSuccess = (actionType: string, data: any): IncidenciasAction => ({
    type: IncidenciasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const incidenciasApiResponseError = (actionType: string, error: string): IncidenciasAction => ({
    type: IncidenciasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getIncidencia = (id: string): IncidenciasAction => ({
    type: IncidenciasActionTypes.GET_INCIDENCIA,
    payload: { id },
});

export const addIncidencia = (incidencia:any):IncidenciasAction=>({
    type:IncidenciasActionTypes.ADD_INCIDENCIA,
    payload:incidencia
})
export const updateIncidencia = (incidencia:any):IncidenciasAction=>({
    type:IncidenciasActionTypes.UPDATE_INCIDENCIA,
    payload:incidencia
})
export const deleteIncidencia = (id:string):IncidenciasAction=>({
    type:IncidenciasActionTypes.DELETE_INCIDENCIA,
    payload:{id}
})

export const listIncidencias = (params:any): IncidenciasAction => ({
    type: IncidenciasActionTypes.LIST_INCIDENCIAS,
    payload: params,
});


export const resetIncidencias = (): IncidenciasAction => ({
    type: IncidenciasActionTypes.RESET,
    payload: {},
});

